<div class="flex flex-col justify-between items-start h-full w-full">
  <div class="flex flex-col justify-start items-start w-full h-full overflow-x-hidden">
    <ng-content></ng-content>
  </div>

  @if (false && !opened) {
    <app-sidebar-item (click)="open()" [icon]="faChevronRight"></app-sidebar-item>
  }
  @if (false && opened) {
    <app-sidebar-item (click)="close()" [icon]="faChevronLeft"></app-sidebar-item>
  }
</div>
